/**
 * Utility to derive the entrypoint ID from the starting route.
 * Used for global metadata injection in Statsig events.
 *
 * No "use client" directive - pure function usable on both client and server.
 */

export type EntrypointId =
  | "triage"
  | "dismissible_cta"
  | "fab"
  | "deep_link"
  | "push"
  | "email"
  | "unknown";

/**
 * Derives the entrypoint ID from the route the user originally entered on.
 *
 * Note: deep_link/push/email would require UTM params (future enhancement).
 */
export function deriveEntrypointId(startingRoute: string): EntrypointId {
  const segment = startingRoute.replace(/^\//, "").split("/")[0] || "";

  switch (segment) {
    case "triaged-cta":
      return "triage";
    case "dismissable-cta":
      return "dismissible_cta";
    case "value-props":
      return "fab";
    default:
      return "unknown";
  }
}
